const searchToggleIcon = document.querySelector("header .search span.toggle");
const searchCloseIcon = document.querySelector(".search-wrapper span.close");
const searchWrapper = document.querySelector(".search-wrapper");
const overlay = document.querySelector("#navigation-overlay");

if (searchToggleIcon && searchWrapper) {

    function toggleSearchPanel() {
        searchToggleIcon.classList.toggle('active');
        searchWrapper.classList.toggle('search-visible');
        overlay.classList.toggle('d-block');
    }

    document.addEventListener('mouseup', (e) => {
        if (
            searchToggleIcon.classList.contains('active')
            && !searchWrapper.contains(e.target)
            && !searchToggleIcon.contains(e.target)
            && overlay.classList.contains('d-block')
        ) {
            toggleSearchPanel();
        }
    });

    searchToggleIcon.addEventListener('click', function (e) {
        e.preventDefault();

        toggleSearchPanel();
        if (overlay.classList.contains('d-block')) {
            const searchInput = document.querySelector(".search-wrapper input[type='search']");
            if (searchInput) {
                searchInput.focus();
            }
        }
    });

    searchCloseIcon.addEventListener('click', function (e) {
        e.preventDefault();
        toggleSearchPanel();
    });
}
